import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { SezioneBeniMobili } from '../../../models/sezioni/sezione-beni-mobili';
import { BeniMobiliAddComponent } from './beni-mobili-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [beni-mobili-mod-add]',
  templateUrl: 'beni-mobili-mod-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class BeniMobiliModAdd {
  @ViewChild('formBeniMobiliAdd') formBeniMobili: BeniMobiliAddComponent;
  @Output()
  onReturn: EventEmitter<SezioneBeniMobili> = new EventEmitter<SezioneBeniMobili>();

  inizializza(urlAddBene: string, idFascicolo: string, idSezione: string) {
   this.formBeniMobili.inizializza(urlAddBene, idFascicolo, idSezione);
   openModal('modaladdBeniMobili');
  }

  createForm() {
    this.formBeniMobili.createForm();
  }

  manageModal(sezione: SezioneBeniMobili) {
    closeModal('modaladdBeniMobili');
    this.onReturn.emit(sezione);
  }
}
